import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    PRODUCT_CATEGORIES_QUERY,
    SINGLE_PRODUCT_CATEGORY_QUERY,
    CREATE_PRODUCT_CATEGORY_MUTATION,
    UPDATE_PRODUCT_CATEGORY_MUTATION,
    DELETE_PRODUCT_CATEGORY_MUTATION
} from "@/graphql/productCategories.js";

const state = {
    productCategories: []
};

const getters = {};

const mutations = {
    [types.SET_PRODUCT_CATEGORIES](state, productCategories) {
        state.productCategories = productCategories;
    },
    [types.SORT_PRODUCT_CATEGORIES](state) {
        state.productCategories.sort(function(a, b) {
            return a.node.name == b.node.name
                ? 0
                : a.node.name > b.node.name
                ? 1
                : -1;
        });
    },
    [types.UPSERT_PRODUCT_CATEGORY](state, productCategory) {
        var index = state.productCategories.findIndex(function(element) {
            return element.node.id == productCategory.id;
        });

        const node = { node: productCategory };

        if (index > -1) {
            state.productCategories.splice(index, 1, node);
        } else {
            state.productCategories.unshift(node);
        }
    },
    [types.DELETE_PRODUCT_CATEGORY](state, productCategory) {
        var index = state.productCategories.find(function(element, index) {
            if (element.id == productCategory.id) {
                return index;
            }
        });

        if (index > -1) {
            state.productCategories.splice(index, 1);
        }
    }
};

const actions = {
    async fetchProductCategories(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PRODUCT_CATEGORIES_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    const productCategories =
                        response.data.tenantProductCategories.edges;

                    // update store
                    context.commit(
                        types.SET_PRODUCT_CATEGORIES,
                        productCategories
                    );

                    // sort
                    context.commit(types.SORT_PRODUCT_CATEGORIES);

                    resolve(productCategories);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleProductCategory(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_PRODUCT_CATEGORY_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const productCategory = JSON.parse(
                        JSON.stringify(response.data.productCategory)
                    );

                    // update store
                    context.commit(
                        types.UPSERT_PRODUCT_CATEGORY,
                        productCategory
                    );

                    // sort
                    context.commit(types.SORT_PRODUCT_CATEGORIES);

                    resolve(productCategory);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createProductCategory(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_PRODUCT_CATEGORY_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const productCategory =
                        response.data.createProductCategory.productCategory;

                    // update store
                    context.commit(
                        types.UPSERT_PRODUCT_CATEGORY,
                        productCategory
                    );

                    // sort
                    context.commit(types.SORT_PRODUCT_CATEGORIES);

                    resolve(productCategory);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateProductCategory(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_PRODUCT_CATEGORY_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const productCategory =
                        response.data.updateProductCategory.productCategory;

                    // update store
                    context.commit(
                        types.UPSERT_PRODUCT_CATEGORY,
                        productCategory
                    );

                    // sort
                    context.commit(types.SORT_PRODUCT_CATEGORIES);

                    resolve(productCategory);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteProductCategory(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_PRODUCT_CATEGORY_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const productCategory =
                        response.data.deleteProductCategory.productCategory;

                    // update store
                    context.commit(
                        types.DELETE_PRODUCT_CATEGORY,
                        productCategory
                    );

                    resolve(productCategory);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
